export function useBuilderShowIf() {
    const hasValue = (fieldName: string) => {
        return `
            let value = options.get('${fieldName}') ?? '';
            return !!value;
        `;
    };

    const hasValueEqualTo = (fieldName: string, value: string | number) => {
        //split fieldName by '.' to get the nested field
        const nestedFields = fieldName.split('.');
        if (nestedFields.length > 1) {
            const nestedField = nestedFields[1];
            return `
                let value = options.get('${nestedFields[0]}')['${nestedField}'] ?? '';
                console.log(fieldName, value);
                return value == '${value}';
            `;
        }
        return `
            let value = options.get('${fieldName}') ?? '';
            return value == '${value}';
        `;
    };
    const hasRichText = (fieldName: string) => {
        return `
            if (typeof window === 'undefined') return false;
            const parser = new DOMParser();
            const htmlString = options.get('${fieldName}') ?? '';
            const doc = parser.parseFromString(htmlString, 'text/html');
            const body = doc.body;
            const textContent = body?.textContent?.trim();
            return !!textContent;
        `;
    };

    const isVideo = (fieldName: string) => {
        return `
            let value = (options.get('${fieldName}') ?? '');
            return value && !value.includes("/image/");
        `;
    };

    return {
        hasValue,
        hasValueEqualTo,
        hasRichText,
        isVideo
    };
}

export function useRichTextFormatting(text: string) {
    if (typeof window === 'undefined') return text;
    const doc = new DOMParser().parseFromString(text, "text/xml");
    const errorNode = doc.querySelector("parsererror");
    if (errorNode) return text;
    const formattedText = doc?.firstChild?.innerHTML ?? "";
    return formattedText;
}

export function richTextHasText(text: string) {
    if (!text) return false;
    const textOnly = text.replace(/<[^>]*>/g, "");
    return textOnly?.trim().length > 0;
}
